import AutoplayController from "~/lib/autoplay_controller"
import { replay } from "~/lib/motion"

// Switching AI AutoPilot on fills the offer's upsell products one by one
export default class extends AutoplayController {
  static targets = ["switch", "slot", "status"]

  reset() {
    this.switchTarget.classList.remove("is-on")
    this.slotTargets.forEach((slot) => slot.classList.remove("is-filled"))
    this.statusTarget.textContent = "Waiting for products…"
    this.statusTarget.classList.remove("is-done")
  }

  async play(wait) {
    await wait(700)
    await this.click(this.switchTarget, wait)
    this.switchTarget.classList.add("is-on")
    this.statusTarget.textContent = "AutoPilot is picking products…"
    for (const slot of this.slotTargets) {
      await wait(650)
      slot.classList.add("is-filled")
      replay(slot.firstElementChild, "is-pop")
    }
    await wait(500)
    this.statusTarget.textContent = "✓ 3 upsell products ready · offer live"
    this.statusTarget.classList.add("is-done")
    replay(this.statusTarget, "is-flash")
  }
}
